import toast from "react-hot-toast";

/** One visible error toast at a time — later errors replace the current one. */
const ERROR_TOAST_ID = "app-error-toast";

export function showErrorToast(message: string): void {
  if (!message.trim()) return;
  toast.error(message, { id: ERROR_TOAST_ID });
}
